import { ActiveConstants } from 'finhelper';
import type { CalendarCouponPayment } from '#app/pages/Relations/CouponDeal/types/couponDealForm';
import { parseCouponDealRecordId } from '#app/pages/Relations/CouponDeal/utils/parseCouponDealRecordId';

/** Числовой id active-dividend / active-coupon из события календаря. */
export function resolveCalendarPaymentRecordId(
  payment?: CalendarCouponPayment | null
): number | null {
  if (!payment) return null;

  const matched = payment.matchedPayout as { id?: unknown; relation_id?: unknown } | undefined;
  const raw = payment.raw as
    | {
        id?: unknown;
        relation_id?: unknown;
        relation?: { id?: unknown };
      }
    | undefined;
  const relationId = raw?.relation?.id;

  return (
    parseCouponDealRecordId(relationId) ??
    parseCouponDealRecordId(payment.relation_id) ??
    parseCouponDealRecordId(raw?.relation_id) ??
    parseCouponDealRecordId(payment.id) ??
    parseCouponDealRecordId(matched?.id) ??
    parseCouponDealRecordId(raw?.id)
  );
}

/** type_id для fetch active-coupon / active-dividend (не пустая строка из календаря). */
export function resolveCalendarPaymentTypeId(
  payment?: CalendarCouponPayment | null
): number | string | null {
  if (!payment) return null;

  const candidates = [
    payment.type_id,
    payment.matchedPayout?.type_id,
    (payment.item as { type_id?: number | string } | undefined)?.type_id,
    (payment.active as { type_id?: number | string } | undefined)?.type_id,
  ];

  for (const raw of candidates) {
    if (raw == null || raw === '') continue;
    const n = Number(raw);
    if (Number.isFinite(n)) return n;
  }

  const kind =
    payment.payment_type ?? (payment.matchedPayout as { kind?: string } | undefined)?.kind;
  if (kind === 'coupon') return ActiveConstants.OBLIGATION;
  if (kind === 'dividend') return ActiveConstants.STOCK;

  return null;
}
